import React, { Component } from 'react'
import Hero from "../commons/Hero";
import Navbar from "../commons/Navbar";



export class Contact extends Component {
  

  render() {
    return (
      <div className="contact">
        <Navbar />

        <Hero 
            heading="Here is how you can reach out to me" 
            image="assets/img/herobg-projects.jpg"
        />

        <div className="container">
          <div className="content">
            
              <ul>

                <li className="entry">
                  <img className="bgimg" src="assets/img/screenshots/lrg/mobile-phone-android-apps-phone-163065@2x.jpg" />
                  <div className="overlay"></div>

                  <div className="info">
                    <h3 className="heading-3 label">
                      Phone
                    </h3>
                    <a href="tel:1-413-758-1519">
                      413-758-1519
                    </a>
                  </div>
                </li>
              
                <li className="entry">
                  <img className="bgimg" src="assets/img/screenshots/lrg/pexels-photo-1591062@2x.jpg" />
                  <div className="overlay"></div>
                  
                  <div className="info">
                    <h3 className="heading-3 label">
                      Email
                    </h3>
                    <a href="mailto: jinjoe@zoho.com">
                      jinjoe@zoho.com
                    </a>
                  </div>
                </li>
              
                <li className="entry">
                  <img className="bgimg" src="assets/img/screenshots/lrg/linkined.jpg" />
                  <div className="overlay"></div>

                  <div className="info">
                    <h3 className="heading-3 label">
                      LinkedIn
                    </h3>
                    <a href="https://www.linkedin.com/in/marcusmckinstry/" target="self">
                      Marcus Mckinstry
                    </a>
                  </div>
                </li>
                
              </ul>
            
          </div>
        </div>
      </div>
    );
  }
}

export default Contact
